import type { KeyTextField } from "@prismicio/client";
import { replaceText } from "@wbly/common";
import type { PaletteColor } from "../types/color-palette";
import { getFormattedPalette } from "./get-formatted-palette";

interface TextOptions {
  promoCode?: string;
  linkText?: string;
  bgColor?: PaletteColor;
  promoTheme?: PaletteColor;
  bannerLink?: string;
}

export function enhancedText(
  text: KeyTextField,
  options: TextOptions = {},
  codedHref?: string
): string {
  const { promoCode, linkText, bgColor, promoTheme, bannerLink } = options;

  const getPromoBox = () =>
    promoCode
      ? `<em
          class="Highlight-promoCode u-bg-palette"
          data-palette="${getFormattedPalette(promoTheme as PaletteColor)}"
        >${promoCode}</em>`
      : "";

  const getPromoLink = () => {
    if (linkText && bannerLink) {
      return `<a
        class="Highlight-link u-color-palette"
        data-palette="${getFormattedPalette(bgColor as PaletteColor)} link"
        href="${bannerLink}"
      >${linkText}</a>`;
    } else if (linkText && codedHref) {
      return `<a
        class="Highlight-link u-color-palette"
        data-palette="${getFormattedPalette(bgColor as PaletteColor)} link"
        href=${codedHref}
      >${linkText}</a>`;
    }
    return "";
  };
  // Replace placeholders with dynamic HTML
  return text
    ? replaceText(text, {
        code: getPromoBox(),
        link: getPromoLink(),
      })
    : null;
}
